import React, { FC } from 'react';
import cs from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { AddEmptyBlock, EventsConfig } from '../../../AddEmptyBlock/AddEmptyBlock';
import { T_KEY } from '../../utils';
import workExperienceBIEvents from '../../utils/biEvents';

import styles from './index.module.scss';

export const EMPTY_T_PREFIX = `${T_KEY}.empty`;

const mpEventsConfig: EventsConfig = {
    type: 'View work experience empty state',
    clickType: 'clicked add work experience',
};

interface AddWorkExperienceBlock {
    setIsDrawerOpen: (isDrawerOpen: boolean) => void;
}

export const AddWorkExperienceBlock: FC<AddWorkExperienceBlock> = ({ setIsDrawerOpen }) => (
    <AddEmptyBlock
        className={styles.emptyWorkExperience}
        wrapperClassName={styles.wrapper}
        contentWrapperClassName={cs(styles.contentWrapper, 'm-20')}
        descriptionClassName="m-b-24"
        leftContent={<div className={styles.image} />}
        descriptionTitle={<I18n k={`${EMPTY_T_PREFIX}.title`} />}
        description={<I18n k={`${EMPTY_T_PREFIX}.description`} />}
        buttonText={<I18n k={`${EMPTY_T_PREFIX}.add_button`} />}
        mpEvents={mpEventsConfig}
        bqEvents={workExperienceBIEvents.clickedOnAddWorkExperience()}
        onClick={() => setIsDrawerOpen(true)}
        isPrivate
    />
);
